var $5929126f62332a39$exports = {};
$5929126f62332a39$exports = {
    "decrease": (args)=>`V\xe4henda ${args.fieldLabel}`,
    "increase": (args)=>`Suurenda ${args.fieldLabel}`,
    "numberField": `Numbri v\xe4li`
};


export {$5929126f62332a39$exports as default};
//# sourceMappingURL=et-EE.mjs.map
